import { GetThunkAPI } from '@reduxjs/toolkit/dist/createAsyncThunk';
import RequestService from '@tcc-online/request-service';
import { NotificationActions } from '../../common/actions/NotificationActions';
import Group from '../types/project/360/Group';

const Admin360GroupService = {
    getGroups,
    getGroup,
    createGroup,
    editGroup,
    deleteGroup,
};

const createUrl = (projectId: number, groupId?: string) => {
    let url = `/admin/products/360/projects/${projectId}/groups`;
    if (groupId) {
        url += `/${groupId}`;
    }
    return url;
};

interface BasePayload {
    projectId: number;
}

async function getGroups(payload: BasePayload, thunkApi?: GetThunkAPI<any>) {
    try {
        return await RequestService.get<Group[]>(createUrl(payload.projectId));
    } catch (e) {
        thunkApi?.dispatch(
            NotificationActions.error('nepodarilo se nacist skupiny'),
        ); // TODO: translate

        throw e;
    }
}

interface GroupPayload extends BasePayload {
    groupId: string;
}

async function getGroup(payload: GroupPayload, thunkApi: GetThunkAPI<any>) {
    const { projectId, groupId } = payload;
    try {
        return await RequestService.get<Group>(createUrl(projectId, groupId));
    } catch (e) {
        thunkApi.dispatch(
            NotificationActions.error('nepodarilo se nacist skupinu'),
        ); // TODO: translate

        throw e;
    }
}

interface CreatePayload {
    name: string;
    color: string;
    minimalEvaluatorCount: number;
}

async function createGroup(
    payload: CreatePayload & BasePayload,
    thunkApi: GetThunkAPI<any>,
) {
    const { projectId, name, color, minimalEvaluatorCount } = payload;
    try {
        return await RequestService.post<CreatePayload, Group>(
            createUrl(projectId),
            { name, color, minimalEvaluatorCount },
        );
    } catch (e) {
        thunkApi.dispatch(
            NotificationActions.error('nepodarilo se vytvorit skupinu'),
        ); // TODO: translate

        throw e;
    }
}

type EditPayload = Partial<CreatePayload>;

async function editGroup(
    payload: EditPayload & GroupPayload,
    thunkApi: GetThunkAPI<any>,
) {
    const { projectId, groupId, name, color, minimalEvaluatorCount } = payload;
    try {
        return await RequestService.patch<EditPayload, Group>(
            createUrl(projectId, groupId),
            {
                name,
                color,
                minimalEvaluatorCount,
            },
        );
    } catch (e) {
        thunkApi.dispatch(
            NotificationActions.error('nepodarilo se upravit skupinu'),
        ); // TODO: translate

        throw e;
    }
}

async function deleteGroup(payload: GroupPayload, thunkApi: GetThunkAPI<any>) {
    const { projectId, groupId } = payload;
    try {
        return await RequestService.delete(createUrl(projectId, groupId));
    } catch (e) {
        thunkApi.dispatch(
            NotificationActions.error('nepodarilo se smazat skupinu'),
        ); // TODO: translate

        throw e;
    }
}

export default Admin360GroupService;
